import type { TOC } from '@ember/component/template-only';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface NoDataComponentInterface {
	Args: {
		type: 'preview' | 'greypanel';
		text: string;
		iconClass?: string;
		icon?: IconName;
		title?: string;
	};
}

const NoDataComponent: TOC<NoDataComponentInterface> = <template>
	<div class="nodata {{@type}}">
		{{#if @icon}}
			<CommonUiIconComponent @name={{@icon}} @size="2xl" />
		{{else}}
			<span class="icon {{@iconClass}}"></span>
		{{/if}}
		{{#if @title}}
			<strong>{{@title}}</strong>
		{{/if}}
		<p>{{{@text}}}</p>
	</div>
</template>;

export default NoDataComponent;
